import { unsafeSVG } from 'lit/directives/unsafe-svg.js'
import { assumeExhaustion, createStringEnum } from '../../lib/typeHelpers.no-deps'

/**
 * Ensure to add new icon name to shared/webcomponents/typings/zaptic-icon.d.ts as well
 */

import actionRaw from '!!raw-loader!../../images/action.svg'
import addDashedCircleRaw from '!!raw-loader!../../images/add-dashed-circle.svg'
import addRaw from '!!raw-loader!../../images/add.svg'
import addStepRaw from '!!raw-loader!../../images/add-step.svg'
import advancedSettingsRaw from '!!raw-loader!../../images/advanced-settings.svg'
import alertRaw from '!!raw-loader!../../images/alert.svg'
import annotateRaw from '!!raw-loader!../../images/annotate.svg'
import annotationArrowRaw from '!!raw-loader!../../images/annotation-arrow.svg'
import annotationLineRaw from '!!raw-loader!../../images/annotation-line.svg'
import arrowDownBoldRaw from '!!raw-loader!../../images/arrow-down-bold.svg'
import arrowDownRaw from '!!raw-loader!../../images/arrow-down.svg'
import arrowLeftRaw from '!!raw-loader!../../images/arrow-left.svg'
import arrowRightRaw from '!!raw-loader!../../images/arrow-right.svg'
import arrowWithLoopRaw from '!!raw-loader!../../images/arrow-with-loop.svg'
import asteriskRaw from '!!raw-loader!../../images/asterisk.svg'
import attachmentRaw from '!!raw-loader!../../images/attachment.svg'
import badConnectionRaw from '!!raw-loader!../../images/bad-connection.svg'
import barcode2Raw from '!!raw-loader!../../images/barcode-2.svg'
import barcodeRaw from '!!raw-loader!../../images/barcode.svg'
import binGreySmallIconRaw from '!!raw-loader!../../images/bin-grey-small.svg'
import binRaw from '!!raw-loader!../../images/bin.svg'
import bookRaw from '!!raw-loader!../../images/book.svg'
import brokenLogoRaw from '!!raw-loader!../../images/broken-logo.svg'
import calendarRaw from '!!raw-loader!../../images/calendar.svg'
import cameraRaw from '!!raw-loader!../../images/camera.svg'
import checkMarkGreyRaw from '!!raw-loader!../../images/checkmark-grey.svg'
import checkmarkInCircleRaw from '!!raw-loader!../../images/checkmark-in-circle.svg'
import checkmarkRaw from '!!raw-loader!../../images/checkmark.svg'
import chevronDownRaw from '!!raw-loader!../../images/chevron-down.svg'
import circleRaw from '!!raw-loader!../../images/circle.svg'
import clipboardGreyRaw from '!!raw-loader!../../images/clipboard-grey.svg'
import clipboardPurpleRaw from '!!raw-loader!../../images/clipboard-purple.svg'
import clockAlarmRaw from '!!raw-loader!../../images/clock-alarm.svg'
import closeCrossRaw from '!!raw-loader!../../images/close-cross.svg'
import cloudCrossRaw from '!!raw-loader!../../images/cloud-cross.svg'
import commentRaw from '!!raw-loader!../../images/comment.svg'
import completedFeedbackRaw from '!!raw-loader!../../images/completed-feedback.svg'
import copyRaw from '!!raw-loader!../../images/copy.svg'
import crossRaw from '!!raw-loader!../../images/cross.svg'
import dashedPlusIconRaw from '!!raw-loader!../../images/dashed-plus-icon.svg'
import deleteCircleRaw from '!!raw-loader!../../images/delete-circle.svg'
import deleteCrossInCircleRaw from '!!raw-loader!../../images/delete-cross-in-circle.svg'
import deleteGreyCrossRaw from '!!raw-loader!../../images/delete-grey-cross.svg'
import deleteTrashRaw from '!!raw-loader!../../images/delete-trash.svg'
import dropboxRaw from '!!raw-loader!../../images/dropbox.svg'
import editRaw from '!!raw-loader!../../images/edit.svg'
import elementCalculationRaw from '!!raw-loader!../../images/element-calculation.svg'
import elementCameraRaw from '!!raw-loader!../../images/element-camera.svg'
import elementDateTimeRaw from '!!raw-loader!../../images/element-date-time.svg'
import elementFilesRaw from '!!raw-loader!../../images/element-files.svg'
import elementGuideRaw from '!!raw-loader!../../images/element-guide.svg'
import elementNumberRaw from '!!raw-loader!../../images/element-number.svg'
import elementReportRaw from '!!raw-loader!../../images/element-report.svg'
import elementSelectRaw from '!!raw-loader!../../images/element-select.svg'
import elementTextCaptureRaw from '!!raw-loader!../../images/element-text-capture.svg'
import elementTextContentRaw from '!!raw-loader!../../images/element-text-content.svg'
import elementUnitsRaw from '!!raw-loader!../../images/element-units.svg'
import elementYesNoRaw from '!!raw-loader!../../images/element-yes-no.svg'
import ellipsisRaw from '!!raw-loader!../../images/ellipsis.svg'
import emailRaw from '!!raw-loader!../../images/email.svg'
import emptyBoxRaw from '!!raw-loader!../../images/empty-box.svg'
import emptyInboxRaw from '!!raw-loader!../../images/empty-inbox.svg'
import emptyResultsRaw from '!!raw-loader!../../images/empty-results.svg'
import emptyWalletRaw from '!!raw-loader!../../images/empty-wallet.svg'
import enterKeyRaw from '!!raw-loader!../../images/enter-key.svg'
import excellenceRaw from '!!raw-loader!../../images/excellence.svg'
import expandRaw from '!!raw-loader!../../images/expand.svg'
import externalLinkRaw from '!!raw-loader!../../images/external-link.svg'
import eyeRaw from '!!raw-loader!../../images/eye.svg'
import feedbackIllustrationsRaw from '!!raw-loader!../../images/feedback-illustrations.svg'
import filterRaw from '!!raw-loader!../../images/filter.svg'
import flowSchedulesRaw from '!!raw-loader!../../images/flow-schedules.svg'
import flowSettingsRaw from '!!raw-loader!../../images/flow-settings.svg'
import flowStatusesRaw from '!!raw-loader!../../images/flow-statuses.svg'
import flowStepsRaw from '!!raw-loader!../../images/flow-steps.svg'
import flowTriggersRaw from '!!raw-loader!../../images/flow-triggers.svg'
import galleryRaw from '!!raw-loader!../../images/gallery.svg'
import gearRaw from '!!raw-loader!../../images/gear.svg'
import googleDocsRaw from '!!raw-loader!../../images/google-docs.svg'
import googleDriveRaw from '!!raw-loader!../../images/google-drive.svg'
import googlesheetsRaw from '!!raw-loader!../../images/google-sheets.svg'
import greyProcedureWrenchInWhiteCircleRaw from '!!raw-loader!../../images/grey-procedure-wrench-in-white-circle.svg'
import guideRaw from '!!raw-loader!../../images/guide.svg'
import guideSmallRaw from '!!raw-loader!../../images/guide-small.svg'
import hashtagRaw from '!!raw-loader!../../images/hashtag.svg'
import helpRaw from '!!raw-loader!../../images/help.svg'
import identityCheckRaw from '!!raw-loader!../../images/identity-check.svg'
import imageArrowRaw from '!!raw-loader!../../images/image-arrow.svg'
import infoBoldRaw from '!!raw-loader!../../images/info-bold.svg'
import infoBookRaw from '!!raw-loader!../../images/info-book.svg'
import infoRaw from '!!raw-loader!../../images/info.svg'
import informationRaw from '!!raw-loader!../../images/information.svg'
import invertedCrossRaw from '!!raw-loader!../../images/inverted-cross.svg'
import lightbulbRaw from '!!raw-loader!../../images/lightbulb.svg'
import lightningHollowRaw from '!!raw-loader!../../images/lightning-hollow.svg'
import lightningHollowThinRaw from '!!raw-loader!../../images/lightning-hollow-thin.svg'
import linkIconRaw from '!!raw-loader!../../images/link.svg'
import lockIconRaw from '!!raw-loader!../../images/lock.svg'
import lockOutlineIconRaw from '!!raw-loader!../../images/lock-outline.svg'
import magicRaw from '!!raw-loader!../../images/magic.svg'
import magnifierRaw from '!!raw-loader!../../images/magnifier.svg'
import micRaw from '!!raw-loader!../../images/mic.svg'
import microsoftExcelRaw from '!!raw-loader!../../images/microsoft-excel.svg'
import microsoftPowerpointRaw from '!!raw-loader!../../images/microsoft-powerpoint.svg'
import microsoftSharepointRaw from '!!raw-loader!../../images/microsoft-sharepoint.svg'
import microsoftTeamsRaw from '!!raw-loader!../../images/microsoft-teams.svg'
import microsoftWordRaw from '!!raw-loader!../../images/microsoft-word.svg'
import missingTrainingRaw from '!!raw-loader!../../images/missing-training.svg'
import missingUnitRaw from '!!raw-loader!../../images/missing-unit.svg'
import multimediaRaw from '!!raw-loader!../../images/multimedia.svg'
import newNoteRaw from '!!raw-loader!../../images/new-note.svg'
import noFeedbackRaw from '!!raw-loader!../../images/no-feedback.svg'
import noTrainingRaw from '!!raw-loader!../../images/no-training.svg'
import noteAndCreionRaw from '!!raw-loader!../../images/note-and-creion.svg'
import notFoundRaw from '!!raw-loader!../../images/not-found.svg'
import notificationBellRaw from '!!raw-loader!../../images/notification-bell.svg'
import notionRaw from '!!raw-loader!../../images/notion.svg'
import oneDriveRaw from '!!raw-loader!../../images/onedrive.svg'
import playRaw from '!!raw-loader!../../images/play.svg'
import playVideoRaw from '!!raw-loader!../../images/play-video.svg'
import plusLightningRaw from '!!raw-loader!../../images/plus-lightning.svg'
import plusSignRaw from '!!raw-loader!../../images/plus-sign.svg'
import procedureWrenchRaw from '!!raw-loader!../../images/procedure-wrench.svg'
import questionMarkBlueRaw from '!!raw-loader!../../images/question-mark-blue.svg'
import questionMarkRaw from '!!raw-loader!../../images/question-mark.svg'
import recentRaw from '!!raw-loader!../../images/recent.svg'
import redWarningIconRaw from '!!raw-loader!../../images/red-warning-icon.svg'
import refreshIconRaw from '!!raw-loader!../../images/refresh.svg'
import reportRaw from '!!raw-loader!../../images/report.svg'
import reportSquareRaw from '!!raw-loader!../../images/report-square.svg'
import retryRaw from '!!raw-loader!../../images/retry.svg'
import searchNoResultRaw from '!!raw-loader!../../images/search-no-result.svg'
import searchRaw from '!!raw-loader!../../images/search.svg'
import sendRaw from '!!raw-loader!../../images/send.svg'
import settingsRaw from '!!raw-loader!../../images/settings.svg'
import sheetsIllustrationRaw from '!!raw-loader!../../images/sheets-illustration.svg'
import sortPurpleRaw from '!!raw-loader!../../images/sort-purple.svg'
import sortRaw from '!!raw-loader!../../images/sort.svg'
import speechBubbleRaw from '!!raw-loader!../../images/speech-bubble.svg'
import spilledCoffeeCupRaw from '!!raw-loader!../../images/spilled-coffee-cup.svg'
import squareRaw from '!!raw-loader!../../images/square.svg'
import starRaw from '!!raw-loader!../../images/star.svg'
import starsRaw from '!!raw-loader!../../images/stars.svg'
import starTokenRaw from '!!raw-loader!../../images/star-token.svg'
import statusGreyRaw from '!!raw-loader!../../images/status-grey.svg'
import statusPurpleRaw from '!!raw-loader!../../images/status-purple.svg'
import statusRaw from '!!raw-loader!../../images/status.svg'
import subItemArrowRaw from '!!raw-loader!../../images/sub-item-arrow.svg'
import tableViewRaw from '!!raw-loader!../../images/table-view.svg'
import taskCheckmarkRaw from '!!raw-loader!../../images/task-checkmark.svg'
import taskRaw from '!!raw-loader!../../images/task.svg'
import teamRaw from '!!raw-loader!../../images/team.svg'
import teamFilledRaw from '!!raw-loader!../../images/team-filled.svg'
import textRaw from '!!raw-loader!../../images/text.svg'
import thumbsUpRaw from '!!raw-loader!../../images/thumbs-up.svg'
import tickRaw from '!!raw-loader!../../images/tick.svg'
import tileViewRaw from '!!raw-loader!../../images/tile-view.svg'
import timelineCubeRaw from '!!raw-loader!../../images/timeline-cube.svg'
import timelineLightningRaw from '!!raw-loader!../../images/timeline-lightning.svg'
import timelinePencilRaw from '!!raw-loader!../../images/timeline-pencil.svg'
import trainingCompleteRaw from '!!raw-loader!../../images/trainingStatus/completed.svg'
import trainingInProgressDueSoonRaw from '!!raw-loader!../../images/trainingStatus/in-progress-due-soon.svg'
import trainingInProgressOverdueRaw from '!!raw-loader!../../images/trainingStatus/in-progress-overdue.svg'
import trainingInProgressRaw from '!!raw-loader!../../images/trainingStatus/in-progress.svg'
import trainingNotScheduledRaw from '!!raw-loader!../../images/trainingStatus/not-scheduled.svg'
import trainingNotStartedDueSoonRaw from '!!raw-loader!../../images/trainingStatus/not-started-due-soon.svg'
import trainingNotStartedOverdueRaw from '!!raw-loader!../../images/trainingStatus/not-started-overdue.svg'
import trainingNotStartedRaw from '!!raw-loader!../../images/trainingStatus/not-started.svg'
import trainingRaw from '!!raw-loader!../../images/training.svg'
import trainingSubmittedRaw from '!!raw-loader!../../images/trainingStatus/submitted.svg'
import unitCubePurpleRaw from '!!raw-loader!../../images/unit-cube-purple.svg'
import unitCubeRaw from '!!raw-loader!../../images/unit-cube.svg'
import unitCubesRaw from '!!raw-loader!../../images/unit-cubes.svg'
import unitParameterRaw from '!!raw-loader!../../images/unit-parameter.svg'
import unknownIconRaw from '!!raw-loader!../../images/unknown-icon.svg'
import uploadGreyIconRaw from '!!raw-loader!../../images/upload-grey.svg'
import videoCameraRaw from '!!raw-loader!../../images/video-camera.svg'
import warningTriangleRaw from '!!raw-loader!../../images/warning-triangle.svg'
import waveRaw from '!!raw-loader!../../images/wave.svg'
import whitePlusSignInOffBlackRoundedSquareRaw from '!!raw-loader!../../images/white-plus-sign-in-off-black-rounded-square.svg'
import wrenchBoldRaw from '!!raw-loader!../../images/wrench-bold.svg'
import zapBotFullRaw from '!!raw-loader!../../images/zapbot-full.svg'
import zapBotRaw from '!!raw-loader!../../images/zapbot.svg'
import zapticLogoFullRaw from '!!raw-loader!../../images/zaptic-logo-full.svg'
import zapticLogoSimpleRaw from '!!raw-loader!../../images/zaptic-logo-simple.svg'
import zoomInRaw from '!!raw-loader!../../images/zoom-in.svg'
import zoomOutRaw from '!!raw-loader!../../images/zoom-out.svg'

const actionIcon = unsafeSVG(actionRaw)
const addDashedCircleIcon = unsafeSVG(addDashedCircleRaw)
const addIcon = unsafeSVG(addRaw)
const addStepIcon = unsafeSVG(addStepRaw)
const advancedSettingsIcon = unsafeSVG(advancedSettingsRaw)
const alertIcon = unsafeSVG(alertRaw)
const annotateIcon = unsafeSVG(annotateRaw)
const annotationArrowIcon = unsafeSVG(annotationArrowRaw)
const annotationLineIcon = unsafeSVG(annotationLineRaw)
const arrowDownBoldIcon = unsafeSVG(arrowDownBoldRaw)
const arrowDownIcon = unsafeSVG(arrowDownRaw)
const arrowLeftIcon = unsafeSVG(arrowLeftRaw)
const arrowRightIcon = unsafeSVG(arrowRightRaw)
const arrowWithLoopIcon = unsafeSVG(arrowWithLoopRaw)
const asteriskIcon = unsafeSVG(asteriskRaw)
const attachmentIcon = unsafeSVG(attachmentRaw)
const badConnectionIcon = unsafeSVG(badConnectionRaw)
const barcode2Icon = unsafeSVG(barcode2Raw)
const barcodeIcon = unsafeSVG(barcodeRaw)
const binGreySmallIcon = unsafeSVG(binGreySmallIconRaw)
const binIcon = unsafeSVG(binRaw)
const bookIcon = unsafeSVG(bookRaw)
const brokenLogoIcon = unsafeSVG(brokenLogoRaw)
const calendarIcon = unsafeSVG(calendarRaw)
const cameraIcon = unsafeSVG(cameraRaw)
const checkMarkGreyIcon = unsafeSVG(checkMarkGreyRaw)
const checkmarkIcon = unsafeSVG(checkmarkRaw)
const checkmarkInCircleIcon = unsafeSVG(checkmarkInCircleRaw)
const chevronDownIcon = unsafeSVG(chevronDownRaw)
const circleIcon = unsafeSVG(circleRaw)
const clipboardGreyIcon = unsafeSVG(clipboardGreyRaw)
const clipboardPurpleIcon = unsafeSVG(clipboardPurpleRaw)
const clockAlarmIcon = unsafeSVG(clockAlarmRaw)
const closeCrossIcon = unsafeSVG(closeCrossRaw)
const cloudCrossIcon = unsafeSVG(cloudCrossRaw)
const commentIcon = unsafeSVG(commentRaw)
const completedFeedbackIcon = unsafeSVG(completedFeedbackRaw)
const copyIcon = unsafeSVG(copyRaw)
const crossIcon = unsafeSVG(crossRaw)
const dashedPlusIcon = unsafeSVG(dashedPlusIconRaw)
const deleteCircleIcon = unsafeSVG(deleteCircleRaw)
const deleteCrossInCircleIcon = unsafeSVG(deleteCrossInCircleRaw)
const deleteGreyCrossIcon = unsafeSVG(deleteGreyCrossRaw)
const deleteTrashIcon = unsafeSVG(deleteTrashRaw)
const dropboxIcon = unsafeSVG(dropboxRaw)
const editIcon = unsafeSVG(editRaw)
const elementCalculationIcon = unsafeSVG(elementCalculationRaw)
const elementCameraIcon = unsafeSVG(elementCameraRaw)
const elementDateTimeIcon = unsafeSVG(elementDateTimeRaw)
const elementFilesIcon = unsafeSVG(elementFilesRaw)
const elementGuideIcon = unsafeSVG(elementGuideRaw)
const elementNumberIcon = unsafeSVG(elementNumberRaw)
const elementReportIcon = unsafeSVG(elementReportRaw)
const elementSelectIcon = unsafeSVG(elementSelectRaw)
const elementTextCaptureIcon = unsafeSVG(elementTextCaptureRaw)
const elementTextContentIcon = unsafeSVG(elementTextContentRaw)
const elementUnitsIcon = unsafeSVG(elementUnitsRaw)
const elementYesNoIcon = unsafeSVG(elementYesNoRaw)
const ellipsisIcon = unsafeSVG(ellipsisRaw)
const emailIcon = unsafeSVG(emailRaw)
const emptyBoxIcon = unsafeSVG(emptyBoxRaw)
const emptyInboxIcon = unsafeSVG(emptyInboxRaw)
const emptyResultsIcon = unsafeSVG(emptyResultsRaw)
const emptyWalletIcon = unsafeSVG(emptyWalletRaw)
const enterKeyIcon = unsafeSVG(enterKeyRaw)
const excellenceIcon = unsafeSVG(excellenceRaw)
const expandIcon = unsafeSVG(expandRaw)
const externalLinkIcon = unsafeSVG(externalLinkRaw)
const eyeIcon = unsafeSVG(eyeRaw)
const feedbackIllustrationsIcon = unsafeSVG(feedbackIllustrationsRaw)
const filterIcon = unsafeSVG(filterRaw)
const flowSchedulesIcon = unsafeSVG(flowSchedulesRaw)
const flowSettingsIcon = unsafeSVG(flowSettingsRaw)
const flowStatusesIcon = unsafeSVG(flowStatusesRaw)
const flowStepsIcon = unsafeSVG(flowStepsRaw)
const flowTriggersIcon = unsafeSVG(flowTriggersRaw)
const galleryIcon = unsafeSVG(galleryRaw)
const gearIcon = unsafeSVG(gearRaw)
const googleDocsIcon = unsafeSVG(googleDocsRaw)
const googleDriveIcon = unsafeSVG(googleDriveRaw)
const googlesheetsIcon = unsafeSVG(googlesheetsRaw)
const greyProcedureWrenchInWhiteCircleIcon = unsafeSVG(greyProcedureWrenchInWhiteCircleRaw)
const guideIcon = unsafeSVG(guideRaw)
const guideSmallIcon = unsafeSVG(guideSmallRaw)
const hashtagIcon = unsafeSVG(hashtagRaw)
const helpIcon = unsafeSVG(helpRaw)
const identityCheckIcon = unsafeSVG(identityCheckRaw)
const imageArrowIcon = unsafeSVG(imageArrowRaw)
const infoBoldIcon = unsafeSVG(infoBoldRaw)
const infoBookIcon = unsafeSVG(infoBookRaw)
const infoIcon = unsafeSVG(infoRaw)
const informationIcon = unsafeSVG(informationRaw)
const invertedCrossIcon = unsafeSVG(invertedCrossRaw)
const lightbulbIcon = unsafeSVG(lightbulbRaw)
const lightningHollowIcon = unsafeSVG(lightningHollowRaw)
const lightningHollowThinIcon = unsafeSVG(lightningHollowThinRaw)
const linkIcon = unsafeSVG(linkIconRaw)
const lockIcon = unsafeSVG(lockIconRaw)
const lockOutlineIcon = unsafeSVG(lockOutlineIconRaw)
const magicIcon = unsafeSVG(magicRaw)
const magnifierIcon = unsafeSVG(magnifierRaw)
const micIcon = unsafeSVG(micRaw)
const microsoftExcelIcon = unsafeSVG(microsoftExcelRaw)
const microsoftPowerpointIcon = unsafeSVG(microsoftPowerpointRaw)
const microsoftSharepointIcon = unsafeSVG(microsoftSharepointRaw)
const microsoftTeamsIcon = unsafeSVG(microsoftTeamsRaw)
const microsoftWordIcon = unsafeSVG(microsoftWordRaw)
const missingTrainingIcon = unsafeSVG(missingTrainingRaw)
const missingUnitIcon = unsafeSVG(missingUnitRaw)
const multimediaIcon = unsafeSVG(multimediaRaw)
const newNoteIcon = unsafeSVG(newNoteRaw)
const noFeedbackIcon = unsafeSVG(noFeedbackRaw)
const noTrainingIcon = unsafeSVG(noTrainingRaw)
const noteAndCreionIcon = unsafeSVG(noteAndCreionRaw)
const notFoundIcon = unsafeSVG(notFoundRaw)
const notificationBellIcon = unsafeSVG(notificationBellRaw)
const notionIcon = unsafeSVG(notionRaw)
const oneDriveIcon = unsafeSVG(oneDriveRaw)
const playIcon = unsafeSVG(playRaw)
const playVideoIcon = unsafeSVG(playVideoRaw)
const plusLightningIcon = unsafeSVG(plusLightningRaw)
const plusSignIcon = unsafeSVG(plusSignRaw)
const procedureWrenchIcon = unsafeSVG(procedureWrenchRaw)
const questionMarkBlueIcon = unsafeSVG(questionMarkBlueRaw)
const questionMarkIcon = unsafeSVG(questionMarkRaw)
const recentIcon = unsafeSVG(recentRaw)
const redWarningIcon = unsafeSVG(redWarningIconRaw)
const refreshIcon = unsafeSVG(refreshIconRaw)
const reportIcon = unsafeSVG(reportRaw)
const reportSquareIcon = unsafeSVG(reportSquareRaw)
const retryIcon = unsafeSVG(retryRaw)
const searchIcon = unsafeSVG(searchRaw)
const searchNoResultIcon = unsafeSVG(searchNoResultRaw)
const sendIcon = unsafeSVG(sendRaw)
const settingsIcon = unsafeSVG(settingsRaw)
const sheetsIllustrationIcon = unsafeSVG(sheetsIllustrationRaw)
const sortIcon = unsafeSVG(sortRaw)
const sortPurpleIcon = unsafeSVG(sortPurpleRaw)
const speechBubbleIcon = unsafeSVG(speechBubbleRaw)
const spilledCoffeeCupIcon = unsafeSVG(spilledCoffeeCupRaw)
const squareIcon = unsafeSVG(squareRaw)
const starIcon = unsafeSVG(starRaw)
const starsIcon = unsafeSVG(starsRaw)
const starTokenIcon = unsafeSVG(starTokenRaw)
const statusGreyIcon = unsafeSVG(statusGreyRaw)
const statusIcon = unsafeSVG(statusRaw)
const statusPurpleIcon = unsafeSVG(statusPurpleRaw)
const subItemArrowIcon = unsafeSVG(subItemArrowRaw)
const tableViewIcon = unsafeSVG(tableViewRaw)
const taskCheckmarkIcon = unsafeSVG(taskCheckmarkRaw)
const taskIcon = unsafeSVG(taskRaw)
const teamIcon = unsafeSVG(teamRaw)
const teamFilledIcon = unsafeSVG(teamFilledRaw)
const textIcon = unsafeSVG(textRaw)
const thumbsUpIcon = unsafeSVG(thumbsUpRaw)
const tickIcon = unsafeSVG(tickRaw)
const tileViewIcon = unsafeSVG(tileViewRaw)
const timelineCubeIcon = unsafeSVG(timelineCubeRaw)
const timelineLightningIcon = unsafeSVG(timelineLightningRaw)
const timelinePencilIcon = unsafeSVG(timelinePencilRaw)
const trainingCompleteIcon = unsafeSVG(trainingCompleteRaw)
const trainingIcon = unsafeSVG(trainingRaw)
const trainingInProgressDueSoonIcon = unsafeSVG(trainingInProgressDueSoonRaw)
const trainingInProgressIcon = unsafeSVG(trainingInProgressRaw)
const trainingInProgressOverdueIcon = unsafeSVG(trainingInProgressOverdueRaw)
const trainingNotScheduledIcon = unsafeSVG(trainingNotScheduledRaw)
const trainingNotStartedDueSoonIcon = unsafeSVG(trainingNotStartedDueSoonRaw)
const trainingNotStartedIcon = unsafeSVG(trainingNotStartedRaw)
const trainingNotStartedOverdueIcon = unsafeSVG(trainingNotStartedOverdueRaw)
const trainingSubmittedIcon = unsafeSVG(trainingSubmittedRaw)
const unitCubeIcon = unsafeSVG(unitCubeRaw)
const unitCubesIcon = unsafeSVG(unitCubesRaw)
const unitCubePurpleIcon = unsafeSVG(unitCubePurpleRaw)
const unitParameterIcon = unsafeSVG(unitParameterRaw)
const unknownIcon = unsafeSVG(unknownIconRaw)
const uploadGreyIcon = unsafeSVG(uploadGreyIconRaw)
const videoCameraIcon = unsafeSVG(videoCameraRaw)
const warningTriangleIcon = unsafeSVG(warningTriangleRaw)
const waveIcon = unsafeSVG(waveRaw)
const whitePlusSignInOffBlackRoundedSquareIcon = unsafeSVG(whitePlusSignInOffBlackRoundedSquareRaw)
const wrenchBoldIcon = unsafeSVG(wrenchBoldRaw)
const zapBotFullIcon = unsafeSVG(zapBotFullRaw)
const zapBotIcon = unsafeSVG(zapBotRaw)
const zapticLogoFullIcon = unsafeSVG(zapticLogoFullRaw)
const zapticLogoSimpleIcon = unsafeSVG(zapticLogoSimpleRaw)
const zoomInIcon = unsafeSVG(zoomInRaw)
const zoomOutIcon = unsafeSVG(zoomOutRaw)

export const iconNames = createStringEnum(
    'action',
    'add-dashed-circle',
    'add-step',
    'add',
    'advanced-settings',
    'alert',
    'annotate',
    'annotation-arrow',
    'annotation-line',
    'arrow-down-bold',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-with-loop',
    'asterisk',
    'attachment',
    'bad-connection',
    'barcode-2',
    'barcode',
    'bin-grey-small',
    'bin',
    'book',
    'broken-logo',
    'calendar',
    'camera',
    'checkmark-grey',
    'checkmark-in-circle',
    'checkmark',
    'chevron-down',
    'circle',
    'clipboard-grey',
    'clipboard-purple',
    'clock-alarm',
    'close-cross',
    'cloud-cross',
    'comment',
    'completed-feedback',
    'copy',
    'cross',
    'dashed-plus-icon',
    'delete-circle',
    'delete-cross-in-circle',
    'delete-grey-cross',
    'delete-trash',
    'dropbox',
    'edit',
    'element-calculation',
    'element-camera',
    'element-date-time',
    'element-files',
    'element-guide',
    'element-number',
    'element-report',
    'element-select',
    'element-text-capture',
    'element-text-content',
    'element-units',
    'element-yes-no',
    'ellipsis',
    'email',
    'empty-box',
    'empty-inbox',
    'empty-results',
    'empty-wallet',
    'enter-key',
    'excellence',
    'expand',
    'external-link',
    'eye',
    'feedback-illustrations',
    'filter',
    'flow-schedules',
    'flow-settings',
    'flow-statuses',
    'flow-steps',
    'flow-triggers',
    'gallery',
    'gear',
    'google-docs',
    'google-drive',
    'google-sheets',
    'grey-procedure-wrench-in-white-circle',
    'guide-small',
    'guide',
    'hashtag',
    'help',
    'identity-check',
    'image-arrow',
    'info-bold',
    'info-book',
    'info',
    'information',
    'inverted-cross',
    'lightbulb',
    'lightning-hollow-thin',
    'lightning-hollow',
    'link',
    'lock-outline',
    'lock',
    'magic',
    'magnifier',
    'mic',
    'microsoft-excel',
    'microsoft-powerpoint',
    'microsoft-sharepoint',
    'microsoft-teams',
    'microsoft-word',
    'missing-training',
    'missing-unit',
    'multimedia',
    'new-note',
    'no-feedback',
    'no-training',
    'not-found',
    'note-and-creion',
    'notification-bell',
    'notion',
    'onedrive',
    'play-video',
    'play',
    'plus-lightning',
    'plus-sign',
    'procedure-wrench',
    'question-mark-blue',
    'question-mark',
    'recent',
    'red-warning-icon',
    'refresh',
    'report-square',
    'report',
    'retry',
    'search-no-result',
    'search',
    'send',
    'settings',
    'sheets-illustration',
    'sort-purple',
    'sort',
    'speech-bubble',
    'spilled-coffee-cup',
    'square',
    'star',
    'stars',
    'star-token',
    'status-grey',
    'status-purple',
    'status',
    'sub-item-arrow',
    'table-view',
    'task-checkmark',
    'task',
    'team',
    'team-filled',
    'text',
    'thumbs-up',
    'tick',
    'tile-view',
    'timeline-cube',
    'timeline-lightning',
    'timeline-pencil',
    'training-complete',
    'training-in-progress-due-soon',
    'training-in-progress-overdue',
    'training-in-progress',
    'training-not-scheduled',
    'training-not-started-due-soon',
    'training-not-started-overdue',
    'training-not-started',
    'training-submitted',
    'training',
    'unit-cube-purple',
    'unit-cube',
    'unit-cubes',
    'unit-parameter',
    'unknown-icon',
    'upload-grey',
    'video-camera',
    'warning-triangle',
    'wave',
    'white-plus-sign-in-off-black-rounded-square',
    'wrench-bold',
    'zapbot-full',
    'zapbot',
    'zaptic-logo-full',
    'zaptic-logo-simple',
    'zoom-in',
    'zoom-out'
)

export type IconName = (typeof iconNames)[number]

export function getIcon(iconName: IconName) {
    switch (iconName) {
        case 'action':
            return actionIcon
        case 'add-dashed-circle':
            return addDashedCircleIcon
        case 'add-step':
            return addStepIcon
        case 'add':
            return addIcon
        case 'advanced-settings':
            return advancedSettingsIcon
        case 'alert':
            return alertIcon
        case 'annotate':
            return annotateIcon
        case 'annotation-arrow':
            return annotationArrowIcon
        case 'annotation-line':
            return annotationLineIcon
        case 'arrow-down-bold':
            return arrowDownBoldIcon
        case 'arrow-down':
            return arrowDownIcon
        case 'arrow-left':
            return arrowLeftIcon
        case 'arrow-right':
            return arrowRightIcon
        case 'arrow-with-loop':
            return arrowWithLoopIcon
        case 'asterisk':
            return asteriskIcon
        case 'attachment':
            return attachmentIcon
        case 'bad-connection':
            return badConnectionIcon
        case 'barcode-2':
            return barcode2Icon
        case 'barcode':
            return barcodeIcon
        case 'bin-grey-small':
            return binGreySmallIcon
        case 'bin':
            return binIcon
        case 'book':
            return bookIcon
        case 'broken-logo':
            return brokenLogoIcon
        case 'calendar':
            return calendarIcon
        case 'camera':
            return cameraIcon
        case 'checkmark-grey':
            return checkMarkGreyIcon
        case 'checkmark-in-circle':
            return checkmarkInCircleIcon
        case 'checkmark':
            return checkmarkIcon
        case 'chevron-down':
            return chevronDownIcon
        case 'circle':
            return circleIcon
        case 'clipboard-grey':
            return clipboardGreyIcon
        case 'clipboard-purple':
            return clipboardPurpleIcon
        case 'clock-alarm':
            return clockAlarmIcon
        case 'close-cross':
            return closeCrossIcon
        case 'cloud-cross':
            return cloudCrossIcon
        case 'comment':
            return commentIcon
        case 'completed-feedback':
            return completedFeedbackIcon
        case 'copy':
            return copyIcon
        case 'cross':
            return crossIcon
        case 'dashed-plus-icon':
            return dashedPlusIcon
        case 'delete-circle':
            return deleteCircleIcon
        case 'delete-cross-in-circle':
            return deleteCrossInCircleIcon
        case 'delete-grey-cross':
            return deleteGreyCrossIcon
        case 'delete-trash':
            return deleteTrashIcon
        case 'dropbox':
            return dropboxIcon
        case 'edit':
            return editIcon
        case 'element-calculation':
            return elementCalculationIcon
        case 'element-camera':
            return elementCameraIcon
        case 'element-date-time':
            return elementDateTimeIcon
        case 'element-files':
            return elementFilesIcon
        case 'element-guide':
            return elementGuideIcon
        case 'element-number':
            return elementNumberIcon
        case 'element-report':
            return elementReportIcon
        case 'element-select':
            return elementSelectIcon
        case 'element-text-capture':
            return elementTextCaptureIcon
        case 'element-text-content':
            return elementTextContentIcon
        case 'element-units':
            return elementUnitsIcon
        case 'element-yes-no':
            return elementYesNoIcon
        case 'ellipsis':
            return ellipsisIcon
        case 'email':
            return emailIcon
        case 'empty-box':
            return emptyBoxIcon
        case 'empty-inbox':
            return emptyInboxIcon
        case 'empty-results':
            return emptyResultsIcon
        case 'empty-wallet':
            return emptyWalletIcon
        case 'enter-key':
            return enterKeyIcon
        case 'excellence':
            return excellenceIcon
        case 'expand':
            return expandIcon
        case 'external-link':
            return externalLinkIcon
        case 'eye':
            return eyeIcon
        case 'feedback-illustrations':
            return feedbackIllustrationsIcon
        case 'filter':
            return filterIcon
        case 'flow-schedules':
            return flowSchedulesIcon
        case 'flow-settings':
            return flowSettingsIcon
        case 'flow-statuses':
            return flowStatusesIcon
        case 'flow-steps':
            return flowStepsIcon
        case 'flow-triggers':
            return flowTriggersIcon
        case 'gallery':
            return galleryIcon
        case 'gear':
            return gearIcon
        case 'google-docs':
            return googleDocsIcon
        case 'google-drive':
            return googleDriveIcon
        case 'google-sheets':
            return googlesheetsIcon
        case 'grey-procedure-wrench-in-white-circle':
            return greyProcedureWrenchInWhiteCircleIcon
        case 'guide-small':
            return guideSmallIcon
        case 'guide':
            return guideIcon
        case 'hashtag':
            return hashtagIcon
        case 'help':
            return helpIcon
        case 'identity-check':
            return identityCheckIcon
        case 'image-arrow':
            return imageArrowIcon
        case 'info-bold':
            return infoBoldIcon
        case 'info-book':
            return infoBookIcon
        case 'info':
            return infoIcon
        case 'information':
            return informationIcon
        case 'inverted-cross':
            return invertedCrossIcon
        case 'lightbulb':
            return lightbulbIcon
        case 'lightning-hollow-thin':
            return lightningHollowThinIcon
        case 'lightning-hollow':
            return lightningHollowIcon
        case 'link':
            return linkIcon
        case 'lock-outline':
            return lockOutlineIcon
        case 'lock':
            return lockIcon
        case 'magic':
            return magicIcon
        case 'magnifier':
            return magnifierIcon
        case 'mic':
            return micIcon
        case 'microsoft-excel':
            return microsoftExcelIcon
        case 'microsoft-powerpoint':
            return microsoftPowerpointIcon
        case 'microsoft-sharepoint':
            return microsoftSharepointIcon
        case 'microsoft-teams':
            return microsoftTeamsIcon
        case 'microsoft-word':
            return microsoftWordIcon
        case 'missing-training':
            return missingTrainingIcon
        case 'missing-unit':
            return missingUnitIcon
        case 'multimedia':
            return multimediaIcon
        case 'new-note':
            return newNoteIcon
        case 'no-feedback':
            return noFeedbackIcon
        case 'no-training':
            return noTrainingIcon
        case 'not-found':
            return notFoundIcon
        case 'note-and-creion':
            return noteAndCreionIcon
        case 'notification-bell':
            return notificationBellIcon
        case 'notion':
            return notionIcon
        case 'onedrive':
            return oneDriveIcon
        case 'play-video':
            return playVideoIcon
        case 'play':
            return playIcon
        case 'plus-lightning':
            return plusLightningIcon
        case 'plus-sign':
            return plusSignIcon
        case 'procedure-wrench':
            return procedureWrenchIcon
        case 'question-mark-blue':
            return questionMarkBlueIcon
        case 'question-mark':
            return questionMarkIcon
        case 'recent':
            return recentIcon
        case 'red-warning-icon':
            return redWarningIcon
        case 'refresh':
            return refreshIcon
        case 'report-square':
            return reportSquareIcon
        case 'report':
            return reportIcon
        case 'retry':
            return retryIcon
        case 'search-no-result':
            return searchNoResultIcon
        case 'search':
            return searchIcon
        case 'send':
            return sendIcon
        case 'settings':
            return settingsIcon
        case 'sheets-illustration':
            return sheetsIllustrationIcon
        case 'sort-purple':
            return sortPurpleIcon
        case 'sort':
            return sortIcon
        case 'speech-bubble':
            return speechBubbleIcon
        case 'spilled-coffee-cup':
            return spilledCoffeeCupIcon
        case 'square':
            return squareIcon
        case 'star':
            return starIcon
        case 'stars':
            return starsIcon
        case 'star-token':
            return starTokenIcon
        case 'status-grey':
            return statusGreyIcon
        case 'status-purple':
            return statusPurpleIcon
        case 'status':
            return statusIcon
        case 'sub-item-arrow':
            return subItemArrowIcon
        case 'table-view':
            return tableViewIcon
        case 'task-checkmark':
            return taskCheckmarkIcon
        case 'task':
            return taskIcon
        case 'team':
            return teamIcon
        case 'team-filled':
            return teamFilledIcon
        case 'text':
            return textIcon
        case 'thumbs-up':
            return thumbsUpIcon
        case 'tick':
            return tickIcon
        case 'tile-view':
            return tileViewIcon
        case 'timeline-cube':
            return timelineCubeIcon
        case 'timeline-lightning':
            return timelineLightningIcon
        case 'timeline-pencil':
            return timelinePencilIcon
        case 'training-complete':
            return trainingCompleteIcon
        case 'training-in-progress-due-soon':
            return trainingInProgressDueSoonIcon
        case 'training-in-progress-overdue':
            return trainingInProgressOverdueIcon
        case 'training-in-progress':
            return trainingInProgressIcon
        case 'training-not-scheduled':
            return trainingNotScheduledIcon
        case 'training-not-started-due-soon':
            return trainingNotStartedDueSoonIcon
        case 'training-not-started-overdue':
            return trainingNotStartedOverdueIcon
        case 'training-not-started':
            return trainingNotStartedIcon
        case 'training-submitted':
            return trainingSubmittedIcon
        case 'training':
            return trainingIcon
        case 'unit-cube-purple':
            return unitCubePurpleIcon
        case 'unit-cube':
            return unitCubeIcon
        case 'unit-cubes':
            return unitCubesIcon
        case 'unit-parameter':
            return unitParameterIcon
        case 'unknown-icon':
            return unknownIcon
        case 'upload-grey':
            return uploadGreyIcon
        case 'video-camera':
            return videoCameraIcon
        case 'warning-triangle':
            return warningTriangleIcon
        case 'wave':
            return waveIcon
        case 'white-plus-sign-in-off-black-rounded-square':
            return whitePlusSignInOffBlackRoundedSquareIcon
        case 'wrench-bold':
            return wrenchBoldIcon
        case 'zapbot-full':
            return zapBotFullIcon
        case 'zapbot':
            return zapBotIcon
        case 'zaptic-logo-full':
            return zapticLogoFullIcon
        case 'zaptic-logo-simple':
            return zapticLogoSimpleIcon
        case 'zoom-in':
            return zoomInIcon
        case 'zoom-out':
            return zoomOutIcon
        default:
            assumeExhaustion(iconName)
            return null
    }
}
